import { IPublicForm } from "../../../../Forms/PublicForm/IPublicForm";

import { ICustomValidationModelAccessorViaPublicForm } from "./ICustomValidationFunctionCallContext";

export class CustomValidationModelAccessorViaPublicForm implements ICustomValidationModelAccessorViaPublicForm {
    readonly #publicForm: IPublicForm;

    public constructor(publicForm: IPublicForm) {
        this.#publicForm = publicForm;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get(pathOrArray: string | undefined): any {
        return this.#publicForm.get(pathOrArray);
    }
}
